module.exports = __webpack_public_path__ + "img/howto_insurancestaking_metamask-insurancestaking.26d98cbe.png";